<aside
  class="fixed flex flex-col top-0 px-5 left-0 bg-white dark:bg-gray-900 dark:border-gray-800 text-gray-900 h-screen transition-all duration-300 ease-in-out z-50 border-r border-gray-200"
  [ngClass]="{
    'w-[290px]': (isExpanded$ | async) || (isMobileOpen$ | async) || (isHovered$ | async),
    'w-[90px]': !((isExpanded$ | async) || (isMobileOpen$ | async) || (isHovered$ | async)),
    'translate-x-0': isMobileOpen$ | async,
    '-translate-x-full': !(isMobileOpen$ | async),
    'md:translate-x-0': true
  }" (mouseenter)="onSidebarMouseEnter()" (mouseleave)="sidebarService.setHovered(false)">
  <div class="py-8 hidden md:flex" [ngClass]="{
  'md:justify-center': !((isExpanded$ | async) || (isHovered$ | async)),
  'justify-start': (isExpanded$ | async) || (isHovered$ | async)
}">
    <a routerLink="/">
      @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
      <!-- Text logo -->
      <div class="flex items-center gap-3">
        <!-- Shield Icon -->
        <img class="h-10 w-10" src="/images/logo/shield.svg" alt="AbuseXense Shield Logo" />

        <!-- Logo Text -->
        <div class="flex flex-col leading-tight">
          <div class="flex items-baseline">
            <span class="font-extrabold text-gray-900 dark:text-white text-lg">Abuse</span>
            <span
              class="font-extrabold text-lg bg-gradient-to-r from-[#83B1FF] to-[#5C77FF] bg-clip-text text-transparent">Xense</span>
          </div>
          <span class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">Web Plus Abuse Management</span>
        </div>
      </div>
      } @else {
      <!-- Shield Icon (Collapsed) -->
      <div class="flex-shrink-0">
        <img class="h-8 w-8" src="/images/logo/shield.svg" alt="Shield Logo" />
      </div>
      }
    </a>
  </div>

  <div class="flex flex-col overflow-y-auto duration-300 ease-linear no-scrollbar flex-1 pt-28 lg:pt-0">
    <nav class="mb-6">
      <div class="flex flex-col gap-4">
        <!-- Menu Section -->
        <div>
          <h2 class="mb-4 text-xs uppercase flex leading-[20px] text-gray-400" [ngClass]="{
              'md:justify-center': !(
                (isExpanded$ | async) || (isHovered$ | async)
              ),
              'justify-start': (isExpanded$ | async) || (isHovered$ | async)
            }">
            @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async))
            { Menu }
            @else {
            <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="size-6">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5.99915 10.2451C6.96564 10.2451 7.74915 11.0286 7.74915 11.9951V12.0051C7.74915 12.9716 6.96564 13.7551 5.99915 13.7551C5.03265 13.7551 4.24915 12.9716 4.24915 12.0051V11.9951C4.24915 11.0286 5.03265 10.2451 5.99915 10.2451ZM17.9991 10.2451C18.9656 10.2451 19.7491 11.0286 19.7491 11.9951V12.0051C19.7491 12.9716 18.9656 13.7551 17.9991 13.7551C17.0326 13.7551 16.2491 12.9716 16.2491 12.0051V11.9951C16.2491 11.0286 17.0326 10.2451 17.9991 10.2451ZM13.7491 11.9951C13.7491 11.0286 12.9656 10.2451 11.9991 10.2451C11.0326 10.2451 10.2491 11.0286 10.2491 11.9951V12.0051C10.2491 12.9716 11.0326 13.7551 11.9991 13.7551C12.9656 13.7551 13.7491 12.9716 13.7491 12.0051V11.9951Z"
                fill="currentColor"></path>
            </svg>
            }
          </h2>
          <ul class="flex flex-col gap-1">
            @for (nav of getFilteredNavItems(); track $index;let i = $index) {
            <li>
              @if (nav.subItems) {
              <button (click)="toggleSubmenu('main',i)" class="menu-item group cursor-pointer"
                [class.menu-item-active]="openSubmenu === 'main-' + i"
                [class.menu-item-inactive]="openSubmenu !== 'main-' + i" [ngClass]="{
                    'md:justify-center': !(
                      (isExpanded$ | async) || (isHovered$ | async)
                    ),
                    'md:justify-start':
                      (isExpanded$ | async) || (isHovered$ | async)
                  }">
                <span class="menu-item-icon-size" [class.menu-item-icon-active]="openSubmenu === 'main-' + i"
                  [class.menu-item-icon-inactive]="openSubmenu !== 'main-' + i" [innerHTML]="nav.icon | safeHtml">
                </span>
                @if ((isExpanded$ | async) || (isHovered$ | async) ||
                (isMobileOpen$ | async)) {

                <span class="menu-item-text dark:text-white/90">
                  {{ nav.name }}
                </span>
                }
                @if (nav.new && ((isExpanded$ | async) || (isHovered$ |
                async) || (isMobileOpen$ | async))) {
                <span class="ml-auto absolute right-10 menu-dropdown-badge" [ngClass]="{
                      'menu-dropdown-badge-active': openSubmenu === 'main-' + i,
                      'menu-dropdown-badge-inactive': openSubmenu !== 'main-' + i
                    }">
                  new
                </span>
                }
                @if ((isExpanded$ | async) || (isHovered$ | async) ||
                (isMobileOpen$ | async)) {
                <svg [ngClass]="{
                      'rotate-180 text-brand-500': openSubmenu === 'main-' + i
                    }" width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="ml-auto w-5 h-5 transition-transform duration-200">
                  <path d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                }
              </button>
              <div class="overflow-hidden transition-all duration-300" [id]="'main-' + i" [style.display]="
                    (isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async) 
                      ? 'block' 
                      : 'none'
                  " [ngStyle]="{
                    height:
                      openSubmenu === 'main-' + i
                        ? (subMenuHeights['main-' + i] || 0) + 'px'
                        : '0px'
                  }">
                <ul class="mt-2 space-y-1 ml-9">
                  @for (subItem of nav.subItems; track $index) {
                  <li>
                    <a [routerLink]="subItem.path" routerLinkActive="" (click)="onSubmenuClick()"
                      class="menu-dropdown-item" [ngClass]="{
                              'menu-dropdown-item-inactive': !isActive(subItem.path),
                              'menu-dropdown-item-active': isActive(subItem.path),
                            }">
                      {{ subItem.name }}
                      <span class="flex items-center gap-1 ml-auto">
                        @if (subItem.new) {
                        <span class="menu-dropdown-badge" [ngClass]="{
                              'menu-dropdown-badge-active': isActive(
                                subItem.path
                              ),
                              'menu-dropdown-badge-inactive': !isActive(
                                subItem.path
                              )
                            }">
                          new
                        </span>
                        }
                        @if (subItem.pro) {
                        <span class="ml-auto menu-dropdown-badge-pro" [ngClass]="{
                              'menu-dropdown-badge-pro-active': isActive(
                                subItem.path
                              ),
                              'menu-dropdown-badge-pro-inactive': !isActive(
                                subItem.path
                              )
                            }">
                          pro
                        </span>
                        }
                      </span>
                    </a>
                  </li>
                  }
                </ul>
              </div>
              } @else {
              @if (nav.path) {
              <a *ngIf="!nav.isRootOnly || isRoot" [routerLink]="nav.path"
                class="flex items-center gap-3 px-2 py-2.5 rounded-2xl transition-all duration-200 hover:bg-indigo-100 hover:text-indigo-600 text-gray-600 font-medium dark:text-white/90 dark:hover:text-indigo-600"
                [ngClass]="{
                      'bg-indigo-500 text-white shadow-md': isActive(nav.path)
                    }">
                <span class="flex items-center justify-center w-9 h-9 rounded-xl" [ngClass]="{
                      'bg-white text-white': isActive(nav.path),
                      'bg-indigo-100 text-gray-500': !isActive(nav.path)
                    }" [innerHTML]="nav.icon | safeHtml"></span>
                <span *ngIf="(isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)">
                  {{ nav.name }}
                </span>
              </a>
              }
              }
            </li>
            }
          </ul>
        </div>
        <!-- end main menu -->

        <!-- Others Section -->
        <!-- <div>
          <h2
            class="mb-4 text-xs uppercase flex leading-[20px] text-gray-400"
            [ngClass]="{
              'lg:justify-center': !(
                (isExpanded$ | async) || (isHovered$ | async)
              ),
              'justify-start': (isExpanded$ | async) || (isHovered$ | async)
            }"
          >
            @if (
              (isExpanded$ | async) ||
                (isHovered$ | async) ||
                (isMobileOpen$ | async)
            ) {
              Others
            } @else {
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.99915 10.2451C6.96564 10.2451 7.74915 11.0286 7.74915 11.9951V12.0051C7.74915 12.9716 6.96564 13.7551 5.99915 13.7551C5.03265 13.7551 4.24915 12.9716 4.24915 12.0051V11.9951C4.24915 11.0286 5.03265 10.2451 5.99915 10.2451ZM17.9991 10.2451C18.9656 10.2451 19.7491 11.0286 19.7491 11.9951V12.0051C19.7491 12.9716 18.9656 13.7551 17.9991 13.7551C17.0326 13.7551 16.2491 12.9716 16.2491 12.0051V11.9951C16.2491 11.0286 17.0326 10.2451 17.9991 10.2451ZM13.7491 11.9951C13.7491 11.0286 12.9656 10.2451 11.9991 10.2451C11.0326 10.2451 10.2491 11.0286 10.2491 11.9951V12.0051C10.2491 12.9716 11.0326 13.7551 11.9991 13.7551C12.9656 13.7551 13.7491 12.9716 13.7491 12.0051V11.9951Z"
                  fill="currentColor"
                ></path>
              </svg>
            }
          </h2>

          <ul class="flex flex-col gap-1">
            @for (nav of othersItems; track $index;let i = $index) {
            <li>
              @if (nav.subItems) {
                <button
                  (click)="toggleSubmenu('others',i)"
                  class="menu-item group cursor-pointer"
                  [ngClass]="{
                     'menu-item-active': openSubmenu === 'others-' + i,
                     'menu-item-inactive': openSubmenu !== 'others-' + i,
                    'lg:justify-center': !(
                      (isExpanded$ | async) || (isHovered$ | async)
                    ),
                    'lg:justify-start':
                      (isExpanded$ | async) || (isHovered$ | async)
                  }"
                >
                  <span
                    class="menu-item-icon-size"
                    [ngClass]="{
                      'menu-item-icon-active': openSubmenu === 'others-' + i,
                      'menu-item-icon-inactive': openSubmenu !== 'others-' + i,
                    }"
                    [innerHTML]="nav.icon | safeHtml"
                  >
                  </span>
                  @if ((isExpanded$ | async) || (isHovered$ | async) ||
                  (isMobileOpen$ | async)) {

                  <span class="menu-item-text">
                    {{ nav.name }}
                  </span>
                  } 
                  @if (nav.new && ((isExpanded$ | async) || (isHovered$ |
                  async) || (isMobileOpen$ | async))) {
                  <span
                    class="ml-auto absolute right-10 menu-dropdown-badge"
                    [ngClass]="{
                      'menu-dropdown-badge-active': openSubmenu === 'others-' + i,
                      'menu-dropdown-badge-inactive': openSubmenu !== 'others-' + i
                    }"
                  >
                    new
                  </span>
                  } 
                  @if ((isExpanded$ | async) || (isHovered$ | async) ||
                  (isMobileOpen$ | async)) {
                  <svg
                    [ngClass]="{
                      'rotate-180 text-brand-500': openSubmenu === 'others-' + i
                    }"
                    width="1em"
                    height="1em"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="ml-auto w-5 h-5 transition-transform duration-200"
                  >
                    <path
                      d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  }
                </button>
                <div
                  class="overflow-hidden transition-all duration-300"
                  [id]="'others-' + i"
                  [style.display]="
                    (isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async) 
                      ? 'block' 
                      : 'none'
                  "
                  [ngStyle]="{
                    height:
                      openSubmenu === 'others-' + i
                        ? (subMenuHeights['others-' + i] || 0) + 'px'
                        : '0px'
                  }"
                >
                  <ul class="mt-2 space-y-1 ml-9">
                    @for (subItem of nav.subItems; track $index) {
                    <li>
                      <a
                        [routerLink]="subItem.path"
                        routerLinkActive=""
                        (click)="onSubmenuClick()"
                        class="menu-dropdown-item"
                        [ngClass]="{
                              'menu-dropdown-item-inactive': !isActive(subItem.path),
                              'menu-dropdown-item-active': isActive(subItem.path),
                            }"
                      >
                        {{ subItem.name }}
                        <span class="flex items-center gap-1 ml-auto">
                          @if (subItem.new) {
                          <span
                            class="menu-dropdown-badge"
                            [ngClass]="{
                              'menu-dropdown-badge-active': isActive(
                                subItem.path
                              ),
                              'menu-dropdown-badge-inactive': !isActive(
                                subItem.path
                              )
                            }"
                          >
                            new
                          </span>
                          }
                          @if (subItem.pro) {
                          <span
                            class="ml-auto menu-dropdown-badge-pro"
                            [ngClass]="{
                              'menu-dropdown-badge-pro-active': isActive(
                                subItem.path
                              ),
                              'menu-dropdown-badge-pro-inactive': !isActive(
                                subItem.path
                              )
                            }"
                          >
                            pro
                          </span>
                          }
                        </span>
                      </a>
                    </li>
                    }
                  </ul>
                </div>
              } @else {
                @if (nav.path) {
                <a
                  [routerLink]="nav.path"
                  routerLinkActive="menu-item-active"
                  class="menu-item group"
                  [ngClass]="{ 'menu-item-inactive': !isActive(nav.path) }"
                >
                  <span
                    class="menu-item-icon-size"
                    [ngClass]="{
                      'menu-item-icon-active': isActive(nav.path),
                      'menu-item-icon-inactive': !isActive(nav.path)
                    }"
                    [innerHTML]="nav.icon | safeHtml"
                  >
                  </span>
                  <span
                    class="menu-item-text"
                  >
                    @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
                    {{ nav.name }}
                    }
                  </span>
                </a>
                }
              }
            </li>
            }
          </ul>
        </div> -->
        <!-- end other section -->
      </div>
    </nav>

    <div class="mt-auto pb-8">
      <button type="button" (click)="onSignOut()"
        class="flex w-full items-center gap-3 rounded-2xl py-2.5 font-medium text-gray-600 transition-all duration-200 hover:bg-red-100 hover:text-red-600 dark:text-white/90 dark:hover:bg-red-50 dark:hover:text-red-600"
        [ngClass]="{
          'justify-center': !((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)),
          'justify-start': (isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)
        }">
        <span class="flex items-center justify-center w-9 h-9 rounded-xl bg-red-100 text-red-600">
          <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15.1007 19.247C14.6865 19.247 14.3507 18.9112 14.3507 18.497V14.245H12.8507V18.497C12.8507 19.7396 13.8581 20.747 15.1007 20.747H18.5007C19.7434 20.747 20.7507 19.7396 20.7507 18.497V5.49609C20.7507 4.25345 19.7433 3.24609 18.5007 3.24609H15.1007C13.8581 3.24609 12.8507 4.25345 12.8507 5.49609V9.74501H14.3507V5.49609C14.3507 5.08188 14.6865 4.74609 15.1007 4.74609H18.5007C18.9149 4.74609 19.2507 5.08188 19.2507 5.49609V18.497C19.2507 18.9112 18.9149 19.247 18.5007 19.247H15.1007ZM3.25073 11.9984C3.25073 12.2144 3.34204 12.4091 3.48817 12.546L8.09483 17.1556C8.38763 17.4485 8.86251 17.4487 9.15549 17.1559C9.44848 16.8631 9.44863 16.3882 9.15583 16.0952L5.81116 12.7484H16.0007C16.4149 12.7484 16.7507 12.4127 16.7507 11.9984C16.7507 11.5842 16.4149 11.2484 16.0007 11.2484H5.81528L9.15585 7.90554C9.44864 7.61255 9.44847 7.13767 9.15547 6.84488C8.86248 6.55209 8.3876 6.55226 8.09481 6.84525L3.52309 11.4202C3.35673 11.5577 3.25073 11.7657 3.25073 11.9984Z"
              fill="currentColor" />
          </svg>
        </span>
        @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
        <span>
          Sign out
        </span>
        }
      </button>
    </div>
  </div>
</aside>